import { contextMixin, registry } from "@/context/context";
import GeneralLoaderService from "@/services/GeneralLoaderService";
import API from '@/utils/Api';
import {CountryService} from "@/services/CountryService";
import {CountryApi} from "@/api/CountryApi";
import {AuthService} from "@/services/AuthService";
import {AuthApi} from "@/api/AuthApi";
import {FileService} from "@/services/FileService";
import {FileApi} from "@/api/FileApi";
import {TimeZoneService} from "@/services/TimeZoneService";
import {TimeZoneApi} from "@/api/TimeZoneApi";
import {EventService} from "@/services/EventService";
import {EventApi} from "@/api/EventApi";
import {ClassService} from "@/services/ClassService";
import {ClassApi} from "@/api/ClassApi";
import {StyleService} from "@/services/StyleService";
import {StyleApi} from "@/api/StyleApi";
import {TeacherService} from "@/services/TeacherService";
import {TeacherApi} from "@/api/TeacherApi";
import {LevelsService} from "@/services/LevelsService";
import {LevelsApi} from "@/api/LevelsApi";
import {TypeService} from "@/services/TypeService";
import {TypeApi} from "@/api/TypeApi";
import {ExerciseService} from "@/services/ExerciseService";
import {ExerciseApi} from "@/api/ExerciseApi";

registry(GeneralLoaderService, 'generalLoaderService');
registry(API, 'api');
registry(CountryApi, 'countryRepository');
registry(CountryService, 'countryService');
registry(AuthApi, 'authRepository');
registry(AuthService, 'authService');
registry(FileApi, 'fileRepository');
registry(FileService, 'fileService');
registry(TimeZoneApi, 'timeZoneRepository');
registry(TimeZoneService, 'timeZoneService');
registry(EventApi, 'eventRepository');
registry(EventService, 'eventService');
registry(ClassApi, 'classRepository');
registry(ClassService, 'classService');
registry(StyleApi, 'styleRepository');
registry(StyleService, 'styleService');
registry(TeacherApi, 'teacherRepository');
registry(TeacherService, 'teacherService');
registry(LevelsApi, 'levelsRepository');
registry(LevelsService, 'levelsService');
registry(TypeApi, 'typeRepository');
registry(TypeService, 'typeService');
registry(ExerciseApi, 'exerciseRepository');
registry(ExerciseService, 'exerciseService');

export default contextMixin;


